import { render, staticRenderFns } from "./userArchive.vue?vue&type=template&id=3e1b8300&"
import script from "./userArchive.vue?vue&type=script&lang=js&"
export * from "./userArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports